export * from './panel-plans.descriptor'